const useAuthAdmin = () => {
  const localAuth = localStorage.getItem("auth");
  if (localAuth) {
    const auth = JSON.parse(localAuth);
    if (auth.accessToken && auth.user && auth.user.role === "admin") {
      return true;
    }
    return false;
  }
};

export default useAuthAdmin;
